
import { Component, Vue, Prop } from "vue-property-decorator"
import { LabeledValueWithFieldInfo } from "@/types/user"
import { formatFieldsMixin } from "@/mixins/formatFieldsMixin"

@Component({
	components: {}
})
export default class UserHeaderFields extends Vue {
	@Prop({ default: () => { return {} } })
	userHeaderFieldValues!: { [key: string]: LabeledValueWithFieldInfo }

	@Prop({ default: () => { return [] } })
	excludeFieldIds!: string[]

	public getLabeledValueDisplayLabel (labeledValue: LabeledValueWithFieldInfo): string {
		const label = formatFieldsMixin.methods.getDisplayLabelFromLabeledValueWithFieldInfo(labeledValue)
		return label
	}

	public sanitizeFieldTitle (title: string) : string {
		const result = title.replace(/[^a-zA-Z0-9]/g, "")
		return result
	}

	private get hasUserHeaderFieldValues (): boolean {
		return this.userHeaderFieldValues && Object.keys(this.userHeaderFieldValues).length > 0
	}

	private isUserHeaderFieldExcluded (fieldId: string): boolean {
		return this.excludeFieldIds && this.excludeFieldIds.length > 0 ? this.excludeFieldIds.includes(fieldId) : false
	}
}

